import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { formatCurrntDateTime, formatDateWithDateAndMonthName, getValueFromResource } from '../../../common/timeLiveFunction';
import clsx from 'clsx';
import { Dropdown } from 'react-bootstrap';
import fetchTimeliveAPI from '../../../common/fetchTimeliveAPI';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { ShowToast } from '../../../common/Toastr';
import ScheduleReport from './ScheduleReport';
import { getFiltersByReportAsync, UpdateAccountEmployeeReportSchedulePauseStatus, updateScheduleReportFlag } from './CustomReportViewSlice';
import { useNavigate } from 'react-router-dom';

const ScheduleReportList = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { scheduleUpdatedFlag } = useAppSelector((state) => state.customReportView);
    const { cultureInfoName, sessionAccountEmployeeId, sessionAccountId , accountFeatureList} = useAppSelector((state) => state.globalState);
    const [ScheduleReportList, setScheduleReportList] = useState<any[]>([]);
    const [showScheduleReport, setShowScheduleReport] = useState(false);
    const [duplicateScheduleFlag, setDuplicateScheduleFlag] = useState(false)
    const [scheduleReportId, setScheduleReportId] = useState('');
    const [id, setId] = useState();

    const formatTime12Hour = (dateTime: string | Date) => {
        if (!dateTime) return '';
        const date = new Date(dateTime);
        return date.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
    };

    const getScheduleReportList = async () => {
        try {
            const response = await fetchTimeliveAPI('api/AccountEmployeeReportSchedule/GetAccountEmployeeReportSchedule', 'GET', '', true);
            const json = await response.json();
            if (json.StatusCode === '200') {
                setScheduleReportList(json?.Data);
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        dispatch(updateScheduleReportFlag(false));
        getScheduleReportList();
    }, [scheduleUpdatedFlag])

    const handleDeleteScheduleReport = async (accountEmployeeReportScheduleId: any) => {
        try {
            const result = await ShowSwalWithConfirmation('Are you sure you want to delete this record?', "");
            if (!result) return;
            const response = await fetchTimeliveAPI(`api/AccountEmployeeReportSchedule/DeleteAccountEmployeeReportSchedule/${accountEmployeeReportScheduleId}`, 'DELETE', true);
            const json = await response.json();
            if (json?.StatusCode === '200') {
                setScheduleReportList((prev) => prev.filter((x: any) => x.AccountEmployeeReportScheduleId !== accountEmployeeReportScheduleId));
                await getScheduleReportList();
                ShowToast('Success', json?.ResponseMessage, "success", "toast-top-right");
            } else {
                ShowToast('Error', json?.ResponseMessage, "error", "toast-top-right");
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleEditScheduleReport = async (item: any) => {
        setShowScheduleReport(true);
        setScheduleReportId(item?.AccountReportId);
        setId(item?.AccountEmployeeReportScheduleId);
        try {
            const response = await dispatch(getFiltersByReportAsync(item?.AccountReportId))
        } catch (error) {
            console.log(error);
        }
    }

    const handlePauseScheduleReport = async (item: any) => {
        try {
            const payload = {
                AccountEmployeeReportScheduleId: item?.AccountEmployeeReportScheduleId,
                AccountId: sessionAccountId,
                AccountEmployeeId: sessionAccountEmployeeId,
                IsPaused: !item?.IsPaused
            }
            const response = await dispatch(UpdateAccountEmployeeReportSchedulePauseStatus(payload));
            const json = response?.payload;
            if (json?.StatusCode === '200') {
                ShowToast('Success', json?.ResponseMessage, 'success', 'toast-top-right');
            } else {
                ShowToast('error', json?.ResponseMessage, 'error', 'toast-top-right');
            }
            getScheduleReportList();
        } catch (error) {
            console.log(error);
        }
    }

    const onClose = () => {
        setShowScheduleReport(false);
        const overlay = document.querySelector('.drawer-overlay');
        if (overlay) {
            overlay.remove();
        }

        document.body.style.overflow = '';
        document.body.classList.remove('drawer-end-on');
    }

    return (
        <>
        {/* <div className="card card-custom admin-card">
        </div> */}
            <div className="card-header  card-drop-dr sticky-top bg-white">
                <h3 className="card-title fw-bold headerTitle"  >
                    {getValueFromResource('Scheduled Report List', dispatch, t)}
                </h3>
            </div>
            <div className="table-responsive" style={{ marginTop: 8 }}>
                <table className="table table-row-bordered table-bottom-color align-middle gs-1 gy-1 gx-1" style={{ width: '100%' }}>
                    <thead>
                        <tr className="thHeading align-middle">
                            <th style={{ width: '30%' }}>
                                {getValueFromResource('Name', dispatch, t)}
                            </th>
                            <th style={{ width: '10%' }}>
                                {getValueFromResource('Frequency', dispatch, t)}
                            </th>
                            <th style={{ width: '10%' }}>
                                {getValueFromResource('File Type', dispatch, t)}
                            </th>
                            <th style={{ width: '10%' }}>
                                {getValueFromResource('Status', dispatch, t)}
                            </th>
                            <th style={{ width: '20%' }}>
                                {getValueFromResource('Next Scheduled Date', dispatch, t)}
                            </th>
                            <th style={{ width: '10%' }}>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {ScheduleReportList?.length > 0 && ScheduleReportList.map((item, ind) => {
                            return (
                                <tr key={ind}>
                                    <td>{item?.ScheduleName}</td>
                                    <td>{item?.SystemReportDeliveryFrequency}</td>
                                    <td>{item?.SystemReportFileType}</td>
                                    <td>{item?.Status}</td>
                                    <td>{`${formatDateWithDateAndMonthName(item.NextScheduledDate, cultureInfoName.toString())} ${formatTime12Hour(item.NextScheduledDate)}`}</td>
                                    <td className='text-center'>
                                        <Dropdown
                                            style={{ marginLeft: 1 }}
                                            className={clsx('cursor-pointer symbol')}
                                            data-kt-menu-attach='parent'
                                            data-kt-menu-placement='bottom-end'
                                        >
                                            <Dropdown.Toggle
                                                variant="transparent"
                                                className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                data-tooltip-id="tooltip-Description"
                                                data-tooltip-content=
                                                {getValueFromResource('More', dispatch, t)}
                                                data-tooltip-place="top"
                                            >
                                                <i className="bi bi-three-dots fs-7"></i>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                                <div className='menu-hover-bg-sec'>
                                                    <Dropdown.Item
                                                        id="kt_OffCanvas"
                                                        className="menu-item me-lg-0"
                                                        onClick={() => handleEditScheduleReport(item)}
                                                    >
                                                        <span className="menu-icon custom-menu mb-2">
                                                            <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                        <span className="menu-title custom-menu-fontsize">
                                                            {getValueFromResource('Edit', dispatch, t)}
                                                        </span>
                                                    </Dropdown.Item>
                                                </div>
                                                <div className='separator mb-1 mt-1 opacity-75'></div>
                                                <div className='menu-hover-bg-sec'>
                                                    <Dropdown.Item
                                                        id="kt_OffCanvas"
                                                        className="menu-item me-lg-0"
                                                        onClick={() => handlePauseScheduleReport(item)}
                                                    >
                                                        <span className="menu-icon custom-menu mb-2">
                                                            <i className="bi bi-pause-circle fs-6 iconColor allign">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                        <span className="menu-title custom-menu-fontsize">
                                                            {getValueFromResource('Pause Delivery', dispatch, t)}
                                                        </span>
                                                    </Dropdown.Item>
                                                </div>
                                                <div className='separator mb-1 mt-1 opacity-75'></div>
                                                <div className='menu-hover-bg-sec'>
                                                    <Dropdown.Item
                                                        id="kt_OffCanvas"
                                                        className="menu-item me-lg-0"
                                                        onClick={() => {
                                                            setDuplicateScheduleFlag(true);
                                                            handleEditScheduleReport(item)
                                                        }}
                                                    >
                                                        <span className="menu-icon custom-menu mb-2">
                                                            <i className="bi bi-files fs-6 iconColor allign">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                        <span className="menu-title custom-menu-fontsize">
                                                            {getValueFromResource('Duplicate', dispatch, t)}
                                                        </span>
                                                    </Dropdown.Item>
                                                </div>
                                                <div className='separator mb-1 mt-1 opacity-75'></div>
                                                <div className='menu-hover-bg-sec'>
                                                    <Dropdown.Item
                                                        className="menu-item me-lg-0"
                                                        onClick={() => navigate(`/SchduleReportAudit`,{state: {AccountEmployeeReportScheduleId: item?.AccountEmployeeReportScheduleId}})}
                                                    >
                                                        <span className="menu-icon custom-menu mb-2">
                                                            <i className="bi bi-receipt fs-6 iconColor">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                        <span className="menu-title custom-menu-fontsize">
                                                            {getValueFromResource('Log', dispatch, t)}
                                                        </span>
                                                    </Dropdown.Item>
                                                </div>
                                                <div className='separator mb-1 mt-1 opacity-75'></div>
                                                <div className='menu-hover-bg-danger'>
                                                    <Dropdown.Item
                                                        className="menu-item me-lg-0"
                                                        onClick={() => handleDeleteScheduleReport(item?.AccountEmployeeReportScheduleId)}
                                                    >
                                                        <span className="menu-icon custom-menu mb-2">
                                                            <i className="bi bi-trash fs-6 delete-menu-icon-color allign">
                                                                <span className="path1"></span>
                                                                <span className="path2"></span>
                                                            </i>
                                                        </span>
                                                        <span className="menu-title delete-menu custom-menu-fontsize">
                                                            {getValueFromResource('Delete', dispatch, t)}
                                                        </span>
                                                    </Dropdown.Item>
                                                </div>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
                {ScheduleReportList.length === 0 &&
                    <div className='mt-4'>
                        <p className='noDataFound'>
                            {getValueFromResource('No Record Found', dispatch, t)}
                        </p>
                    </div>
                }
            </div>
            {showScheduleReport && <ScheduleReport  onClose={onClose} AccountReportId={scheduleReportId} scheduleReportId={id} duplicateSchedule={duplicateScheduleFlag} setDuplicateScheduleFlag={setDuplicateScheduleFlag} moveTo={'ScheduleReportTab'}/>}
        </>
    )
}

export default ScheduleReportList